import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { EvidenceNotification } from 'src/app/_model/evidence-notification';
import { Evidence } from 'src/app/_model/evidence';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';

const EVENTS_API_URL = environment.api_url + "/event";

const headers = new HttpHeaders({
  'Content-Type': 'application/json',
  "Access-Control-Allow-Origin": environment.api_url,
  "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Accept, Authorization, X-Request-With, Access-Control-Request-Method, Access-Control-Request-Headers",
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT",
  "Access-Control-Max-Age": "300"
});

@Injectable({ providedIn: 'root' })
export class EvidenceNotificationService {

  public evidenceListener: EventEmitter<EvidenceNotification> = new EventEmitter();
  private polling = new Map<string, boolean>();

  constructor(private http: HttpClient) {}

  waitForResponse(evidence: Evidence) {
    if (this.polling.get(evidence.evidenceUUID)) return;
    this.polling.set(evidence.evidenceUUID, true);

    const httpOptions = { headers: headers };

    const poll = async () => {
      while (this.polling.get(evidence.evidenceUUID)) {
        try {
          const notification = await firstValueFrom(
            this.http.get<EvidenceNotification>(
              `${EVENTS_API_URL}/evidence/${evidence.evidenceUUID}`,
              httpOptions
            )
          );

          if (notification) {
            this.evidenceListener.emit(notification);
          }
        } catch (err) {
          console.error('Error en long polling', err);
        }

        // Espera 30 segundos antes de volver a intentar
        await new Promise((res) => setTimeout(res, 30_000));
      }
    };

    poll();
  }

  stopPolling(evidenceUUID: string) {
    this.polling.set(evidenceUUID, false);
  }
}
